import { baseApi } from 'api'
import { ApiResponse } from 'helpers/types'
import { NotificationListResponse, NumberOfNotViewedResponse } from 'schema'

import { TNotification, TTotalNotViewedNotification } from '../types'

export const notificationApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // TODO пустой request
    getNotificationList: build.query<TNotification[], string>({
      query: () => ({
        url: 'notification',
        method: 'GET'
      }),
      transformResponse: (response: ApiResponse<NotificationListResponse>) => response.data.notification
    }),
    // TODO пустой request
    getNumberOfNotViewedList: build.query<TTotalNotViewedNotification['total'], string>({
      query: () => ({
        url: 'notification/number-of-not-viewed',
        method: 'GET'
      }),
      transformResponse: (response: ApiResponse<NumberOfNotViewedResponse>) => response.data.total
    }),
    getAllNotificationsViewed: build.mutation({
      query: () => ({
        url: 'notification/set-all-viewed',
        method: 'PUT'
      })
    })
  }),
  overrideExisting: false
})

export const {
  useLazyGetNotificationListQuery,
  useGetNumberOfNotViewedListQuery,
  useGetAllNotificationsViewedMutation
} = notificationApi
